import { InjectionToken, Injector, Type } from '@angular/core';

export class DynamicDialogInjector implements Injector {
    constructor(
        private readonly parentInjector: Injector,
        private readonly additionalTokens: WeakMap<any, any>
    ) {}

    get<T>(token: Type<T> | InjectionToken<T>, notFoundValue?: T): T;
    get(token: any, notFoundValue?: any): any;
    get(token: any, notFoundValue?: any, flags?: any): any {
        const value: any = this.additionalTokens.get(token);

        if (value) {
            return value;
        }

        return this.parentInjector.get<any>(token, notFoundValue);
    }
}
